export const getFilteredOrders = (orders, limitOrders, activeTab) => {

    if (activeTab === "limit") {
        return limitOrders;
    }
    else {
        return orders;
        // return orders.  filter(order => order.square_off === "0");
    }
};

export const normalizeExchange = (exchange) => {
    return exchange === "EQUITY" || exchange === "EQUITY(INDEX)" ? "NFO" : exchange;
};

export const getPriceDifferenceColor = (priceDifference) => {
    if (priceDifference < 0) return "text-red-500";   
    if (priceDifference > 0) return "text-green-500"; 
    return "text-gray-500";                           
};